/**
 * @generated SignedSource<<e13c90d52b9054969237575e92f32fdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type TranscriptModalHeader_note$data = {
  readonly canUnlockNote: boolean;
  readonly id: string;
  readonly isLocked: boolean;
  readonly noteuserSet: ReadonlyArray<{
    readonly id: string;
    readonly lastSeenAt: string | null;
    readonly user: {
      readonly __typename: "User";
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly internalAttributes: {
        readonly invitable: boolean;
      } | null;
      readonly isActive: boolean;
      readonly isConfigured: boolean;
      readonly isExternal: boolean;
      readonly isGuest: boolean;
      readonly isTopUser: boolean;
      readonly type: UserType;
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingPhaseContext_note" | "NoteHeader_note">;
  readonly " $fragmentType": "TranscriptModalHeader_note";
};
export type TranscriptModalHeader_note$key = {
  readonly " $data"?: TranscriptModalHeader_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModalHeader_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModalHeader_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUnlockNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastSeenAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConfigured",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTopUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserInternalAttributes",
              "kind": "LinkedField",
              "name": "internalAttributes",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invitable",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteHeader_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingPhaseContext_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "10c9bacf48f960a6b8462202158dd76a";

export default node;
